import React from "react";
import Tabs from '../../../sharedComponents/Tabs';
import EventFeedbackQuestions from "./EventFeedbackQuestions/EventFeedbackQuestions";

export default ({
  feedbackData = {}
}) => {
  return (
    <div>
      <Tabs tabs={['Questions']} selectedTab='Questions' setSelectedTab={() => {}} />
      <EventFeedbackQuestions feedbackData={feedbackData} />
    </div>
  )
}